import { atom } from 'recoil'

export const UserState = atom({
  key: 'userState',
  default: {
    username: '',
    role: '',
    unit: '',
    subUnit: '',
    id: ''
  },
})
